/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function FloorFromJSON(json) {
    return FloorFromJSONTyped(json, false);
}
export function FloorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'floorId': !exists(json, 'floorId') ? undefined : json['floorId'],
        'buildingId': !exists(json, 'buildingId') ? undefined : json['buildingId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'floorCode': !exists(json, 'floorCode') ? undefined : json['floorCode'],
        'floorName': !exists(json, 'floorName') ? undefined : json['floorName'],
        'floorSortNum': !exists(json, 'floorSortNum') ? undefined : json['floorSortNum'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'floorplanFilenameSimple': !exists(json, 'floorplanFilenameSimple') ? undefined : json['floorplanFilenameSimple'],
        'floorplanFilenameFull': !exists(json, 'floorplanFilenameFull') ? undefined : json['floorplanFilenameFull'],
        'coordinateNorth': !exists(json, 'coordinateNorth') ? undefined : json['coordinateNorth'],
        'coordinateSouth': !exists(json, 'coordinateSouth') ? undefined : json['coordinateSouth'],
        'coordinateEast': !exists(json, 'coordinateEast') ? undefined : json['coordinateEast'],
        'coordinateWest': !exists(json, 'coordinateWest') ? undefined : json['coordinateWest'],
    };
}
export function FloorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'floorId': value.floorId,
        'buildingId': value.buildingId,
        'propertyId': value.propertyId,
        'floorCode': value.floorCode,
        'floorName': value.floorName,
        'floorSortNum': value.floorSortNum,
        'notes': value.notes,
        'floorplanFilenameSimple': value.floorplanFilenameSimple,
        'floorplanFilenameFull': value.floorplanFilenameFull,
        'coordinateNorth': value.coordinateNorth,
        'coordinateSouth': value.coordinateSouth,
        'coordinateEast': value.coordinateEast,
        'coordinateWest': value.coordinateWest,
    };
}
